import { Fragment } from "react";
import { baseUrl } from "../../utils/apiData";
import "./TitleBigridInfo.scss";

const TitleBigridInfo = ({
  theme,
  des,
  title,
  img,
  clickHandler,
  category,
  link,
  danger,
}) => {
  return (
    <section className={`title_bigrid_info ${theme}`}>
      <div className="content_wrap p_top p_bottom">
        <div className="title">
          {category && <p className="wow fadeInUp t-12">{category}</p>}
          <h2 className="wow fadeInUp">{title}</h2>
        </div>
        <div className="bi_grid">
          <div className="img_wrap wow fadeInUp">
            <img src={`${baseUrl}/${img}`} alt="img" />
          </div>
          <div className="text">
            {danger ? (
              <div
                className="danger_html"
                dangerouslySetInnerHTML={{ __html:danger }}
              ></div>
            ) : (
              <Fragment>
                <p className="t-16 wow fadeInUp" data-wow-delay="0.1s">
                  {des}
                </p>

                {link ? (
                  <a href={link} target="_blank">
                    {" "}
                    <button
                      type="button"
                      className="wow fadeInUp"
                      onClick={clickHandler}
                      data-wow-delay="0.3s"
                    >
                      Know More
                    </button>
                  </a>
                ) : (
                  <button
                    type="button"
                    className="wow fadeInUp"
                    onClick={clickHandler}
                    data-wow-delay="0.3s"
                  >
                    Know More
                  </button>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TitleBigridInfo;
